export const TITLE_SIZE = 16;
export const SUBTITLE_SIZE = 14;
export const DASHBOARD_RADIUS = 6;

export const STANDARD_INPUT_WIDTH = 220;
export const SEARCH_BUTTON_WIDTH = 180;
export const STANDARD_MOBILE_INPUT_HEIGHT = 48;
export const STANDARD_INPUT_HEIGHT = 60;
export const STANDARD_INPUT_RADIUS = 6;
export const COLUMN_BREAKPOINT = 6;
export const COLUMN_MEDIUM = 180;
export const COLUMN_LARGE = 240;
export const SVG_SIZE = 25;
export const HEADER_SIZE_MOBILE = 22;
export const HEADER_SIZE_DESKTOP = 28;
